import React, { useState } from 'react'
import { makeStyles } from "@material-ui/core/styles"
import { IconButton, TextField } from '@material-ui/core'
import InputIcon from './input_icon'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
const useStyles = makeStyles(theme => ({
    root: {
        display: "block",
        "& .MuiFormLabel-root": {
            color: "rgba(46, 39, 68, 0.4)",
            backgroundColor: "transparent",
            borderRadius: "14px",
            fontSize: ".9rem",
            outline: 0
        },
        "& .MuiInputBase-root": {
            backgroundColor: "#ffffff",
            borderRadius: "15px",
            display: "flex",
            fontFamily: 'VazirEnglish',
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(227, 239, 245, 0.7)"
        },
        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
            paddingLeft: "10px",
        },
        "& .PrivateNotchedOutline-legendLabelled-6 > span": {
            paddingRight: "5px",
            paddingLeft: "25px"
        }
    },
    labelOffset: {
        transform: "translate(44px, 20px) scale(1)",
    },
    notchedOutline: {
        borderColor: "rgba(227, 239, 245, 0.7)"
    }
}))

export default function LoginCustomInput(props) {
    const classes = useStyles()
    const [shrink, setShrink] = useState()
    const [isPasswordType, setIsPasswordType] = useState(props.isPassword ? false : true)

    const onFocus = (event) => {
        setShrink(true)
    }

    const onBlur = (event) => {
        if (event.target.value.length === 0)
            setShrink(false)
    }

    return (
        <div style={{ position: "relative" }}>
            <TextField
                className={classes.root}
                variant="outlined"
                placeholder={props.placeholder}
                onFocus={onFocus}
                multiline={props.multiline ? true : false}
                onKeyPress={props.enterPressed}
                rows={props.multiline ? 2 : 0}
                type={!isPasswordType ? "password" : "text"}
                onBlur={onBlur}
                InputLabelProps={{ shrink: shrink, classes: { root: classes.labelOffset } }}
                helperText={props.helperText}
                onChange={props.onChange}
                InputProps={{
                    classes: {
                        notchedOutline: classes.notchedOutline
                    },
                    startAdornment: (
                        <InputAdornment position="start">
                            <InputIcon icon={props.icon} color={props.color} />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        (props.isPassword !== undefined && props.isPassword) &&
                        <InputAdornment position="end">
                            <IconButton onClick={() => setIsPasswordType(!isPasswordType)}>
                                {
                                    isPasswordType ?
                                        <Visibility />
                                        :
                                        <VisibilityOff />
                                }
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            >
            </TextField>
        </div>
    )
}